/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGeneralApiCall } from "@/services/useGeneralApiCall";
import BaseUrl from "@/BaseUrl";
import { useNavigate } from "react-router-dom";
import DummyImage from "../../public/images/dummy_image.jpg";
const StyleSearchResults = () => {
  const { searchTerm } = useParams<{ searchTerm: string }>();
  const { getApi } = useGeneralApiCall();
  const [results, setResults] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
  useEffect(() => {
    if (!searchTerm) return;
    setLoading(true);
    setError(null);
    getApi(`${BaseUrl()}/api/style/v1/stylekuchbhi/elasticsearch/?q=${searchTerm}`)
      .then((res: any) => {
        setResults(res?.data?.results || []);
      })
      .catch((err: any) => {
        setError("Failed to fetch results " + (err.message || ""));
      })
      .finally(() => setLoading(false));
  }, [searchTerm, getApi]);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Results for: <span className="text-blue-600">{searchTerm}</span></h2>
      {loading && <div>Loading...</div>}
      {error && <div className="text-red-500">{error}</div>}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {results.length === 0 && !loading && <div>No results found.</div>}
       
      
          {results?.map((image) => (
            <a
              key={image.style_id}
              className="preview-item"
              href={`/style/details/${image?.style_id}`}
              onClick={e => {
                if (
                  e.button === 0 && // left click
                  !e.metaKey &&
                  !e.ctrlKey &&
                  !e.altKey &&
                  !e.shiftKey
                ) {
                  e.preventDefault();
                  navigate(`/style/details/${image?.style_id}`);
                }
                // Otherwise, let the browser handle (right/middle/modifier)
              }}
              style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}
            >
              <img
                src={
                  image?.cover_image_url || DummyImage
                }
                className="preview-image"
                alt={`Preview of ${image.category}`}
              />
              <div className="image-info">
                <p>{image.name}</p>
              </div>
            </a>
          ))}
      </div>
    </div>
  );
};

export default StyleSearchResults;
